import React from 'react';
//material
import {Card, withStyles, CardMedia, CardContent, CardActionArea} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './competition-item-styles';
//utils
import { TeamPlayStatus } from '../../../utils/constants';
//lib
import Moment from 'moment';

const CompetitionItemView = (props) => {
  const {classes, isLoading, competition, viewCompetition, completeRegistration} = props;

  const getStatus = () => {
    switch (competition.teamPlayStatus.id) {
      case TeamPlayStatus.Won:
        return 'WINNER';
      case TeamPlayStatus.Eliminated:
        return 'ELIMINATED';
      case TeamPlayStatus.Undrawn:
        return (
          'Draw Date: ' +
          Moment(new Date(competition.drawDate)).format('Do MMM YYYY')
        );
      case TeamPlayStatus.Ready:
        return 'Waiting for Opponent';
      case TeamPlayStatus.Playing:
        return (
          'Match Deadline: ' +
          Moment(new Date(competition.currentRoundEndDate)).format(
            'Do MMM YYYY',
          )
        );
      case TeamPlayStatus.Incomplete:
        return 'Registration Incomplete';
    }
  };

  const onClick = () => {
    if (competition.teamPlayStatus.id !== TeamPlayStatus.Incomplete) {
      viewCompetition(competition.competitionId, competition.competitionPlayerId)
    } else {
      completeRegistration(competition.inviteCode)
    }
  };

  return (
    <Card>
      <CardActionArea
        disableRipple={isLoading}
        onClick={!isLoading ? onClick : null}>
        {
          isLoading ?
            <Skeleton variant={'rect'} height={165} /> :
            <CardMedia
              title={'Competition Image'}
              image={competition.competitionImageUrl}
              className={classes.img}
            />
        }

        <CardContent className={classes.cardContent}>
          {
            isLoading ?
              <Skeleton height={24}/> :
              <div className={classes.name}>
                {competition.competitionName}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.subtitle}>
                {competition.teamName}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} className={classes.skeletonStatus} /> :
              <div className={classes.status}>
                {getStatus()}
              </div>

          }
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default withStyles(styles) (CompetitionItemView);
